<script setup lang="ts">
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import { getTextVariant } from '@/utils/stringUtils';
import EditorDetail from '@/components/modal/worksheet/EditorDetail.vue';

interface Props {
  tours: any;
  isOutsideTours: boolean;
  langQuote?: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{ handleSaveDataEdit: [value: any] }>();

const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;
const additionalDetailKey = getTextVariant(props.langQuote, 'additionalDetailsEn', 'additionalDetailsFr');

const handleSaveDataEdit = (event: string, field: string) => {
  const data = {
    field: field,
    value: event
  };
  emits('handleSaveDataEdit', data);
};
</script>

<template>
  <div class="tour-worksheet">
    <div class="promotions" v-if="!isOutsideTours && authorizations.worksheet_tour_other_section.promotions_view">
      <div class="lead-promotions flex align-items-center justify-content-between">
        {{ $t('worksheet.promotions') }}
      </div>
      <EditorDetail :dataEdited="tours.promotions" :permission="authorizations.worksheet_tour_other_section.promotions_edit" @handleSaveDataEdit="handleSaveDataEdit($event, 'promotions')" />
    </div>

    <div class="additional-hotel" v-if="!isOutsideTours && authorizations.worksheet_tour_other_section.additional_info_view">
      <div class="lead-additional-tour">{{ $t('worksheet.additional_tour_detail') }}</div>
      <EditorDetail :dataEdited="tours[additionalDetailKey]" :permission="authorizations.worksheet_tour_other_section.additional_info_edit" @handleSaveDataEdit="handleSaveDataEdit($event, additionalDetailKey)" />
    </div>

    <div class="internal-comment" v-if="isOutsideTours && authorizations.worksheet_tour_other_section.agency_comment_view">
      <div class="lead-comment">{{ $t('worksheet.agency_comment') }}</div>
      <EditorDetail :dataEdited="tours.comment" :permission="authorizations.worksheet_tour_other_section.agency_comment_edit" @handleSaveDataEdit="handleSaveDataEdit($event, 'comment')" />
    </div>
  </div>
</template>
